require('./bootstrap');

// Components
require('./components/utilities');
require('./components/disclaimer');
require('./components/colorbox');
require('./components/post');
require('./components/newsletters');
// Blocks
require('./blocks/accordion');
require('./blocks/stats');
require('./blocks/tabs');
